import React, { useState, useEffect } from 'react';

const bannerStyle = {
  position: 'fixed',
  bottom: 0,
  left: 0,
  right: 0,
  background: '#d32f2f',
  color: 'white',
  textAlign: 'center',
  padding: '10px 16px',
  fontSize: '14px',
  fontWeight: 500,
  zIndex: 9999,
  transition: 'transform 0.3s ease',
};

const OfflineBanner = () => {
  const [isOffline, setIsOffline] = useState(!navigator.onLine);

  useEffect(() => {
    const handleOffline = () => setIsOffline(true);
    const handleOnline = () => setIsOffline(false);

    window.addEventListener('offline', handleOffline);
    window.addEventListener('online', handleOnline);

    return () => {
      window.removeEventListener('offline', handleOffline);
      window.removeEventListener('online', handleOnline);
    };
  }, []);

  if (!isOffline) return null;

  return (
    <div style={bannerStyle} role="alert">
      You are offline. Some features may be unavailable.
    </div>
  );
};

export default OfflineBanner;
